import React, { useEffect, useRef } from "react";

import { DataGrid } from "@mui/x-data-grid";
import { useTheme, styled } from "@mui/material";

import { pick } from "lodash";

import CustomPagination from "./CustomPagination";
import { generateDataGridLocaleText } from "src/_utils";
import { useTranslation } from "react-i18next";

const CustomStyleDataGrid = styled(DataGrid)(({ theme }) => ({
    '&.MuiDataGrid-root .MuiDataGrid-cell:focus-within': {
        outline: 'none',
    },
    '&.MuiDataGrid-root .MuiDataGrid-row': {
        cursor: "pointer"
    },
    // Row highlight states for time thresholds
    // Applies background to all cells in the row
    '& .MuiDataGrid-row.row-waiting-24h .MuiDataGrid-cell': {
        backgroundColor: '#FFD69B',
    },
    '& .MuiDataGrid-row.row-waiting-72h .MuiDataGrid-cell': {
        backgroundColor: '#F8A2A2',
    },
    '& .MuiDataGrid-row.row-admin-order-pending .MuiDataGrid-cell': {
        backgroundColor: '#80c8ed',
    },
}));

export default function DataTable({
    customComponents = [],
    page,
    onPageChange,
    tableId = "DATA-TABLE-ID",
    ...props
}) {
    const components = {
        Pagination: CustomPagination,
    }
    const { t } = useTranslation('datagrid');
    const theme = useTheme()
    // const { t } = useTranslation();
    const virtualScrollerElement = useRef(null);
    const headerElement = useRef(null);
    // Guards the retry below: without it, every render queued another timeout.
    const scrollSyncPending = useRef(false);

    //Hande datagrid header scroll when it's RTL
    useEffect(() => {
        if (theme.direction === "rtl" && !virtualScrollerElement.current && !scrollSyncPending.current) {
            scrollSyncPending.current = true;
            setTimeout(() => {
                scrollSyncPending.current = false;
                let table = document.getElementById(tableId)
                let doc = table?.getElementsByClassName("MuiDataGrid-virtualScroller")

                if (!virtualScrollerElement.current && doc && doc.length) {
                    virtualScrollerElement.current = doc[0]
                    virtualScrollerElement.current.addEventListener("scroll", function (event) {
                        if (!headerElement.current) {
                            let header = table?.getElementsByClassName("MuiDataGrid-columnHeadersInner")[0]
                            headerElement.current = header
                        }
                        headerElement.current.style.transform = `translate3d(${Math.ceil(virtualScrollerElement.current.scrollLeft * -1)}px, 0px, 0px)`
                    })
                }
            }, 1000);
        }
    })

    return (
        <span id={tableId}> {/* Wrap the DataGrid in a div with the id */}
            <CustomStyleDataGrid
                pagination
                disableColumnMenu={true}
                paginationMode="server"
                disableVirtualization
                disableSelectionOnClick
                components={pick(components, customComponents)}
                page={page - 1}
                onPageChange={page => onPageChange(page + 1)}
                localeText={generateDataGridLocaleText(t)}
                {...props}
            />
        </span>
    );
}